import { capitalize, map, toUpper } from 'lodash';

export const capitalizeString = (variable: string) => capitalize(variable);

export const titleCase = (value: string) => map(value.split(' '), capitalize).join(' ');

export const upperCase = (value: string) => map(value.split(' '), toUpper).join(' ');
